"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
function Scroller(_a) {
    var { ms, onScroll } = _a, props = __rest(_a, ["ms", "onScroll"]);
    const timeStampRef = React.useRef(0);
    const handleScroll = React.useCallback((e) => {
        if (!onScroll)
            return;
        if (e.timeStamp < timeStampRef.current + ms)
            return;
        timeStampRef.current = e.timeStamp;
        onScroll(e);
    }, [ms, onScroll]);
    return (React.createElement("div", Object.assign({}, props, { onScroll: handleScroll }), props.children));
}
exports.Scroller = Scroller;
